import { ChangeDetectorRef, Component, Input, OnChanges, OnInit } from '@angular/core';
import { Employee } from 'src/app/modules/shared/models/employee';
import { AuthenticationService } from 'src/app/modules/shared/services/authentication.service';
import { EmployeeDetailsViewModel } from 'src/app/modules/shared/viewModels/employeeDetailsViewModel';
import { Account } from 'src/app/modules/shared/models/account';
import { EmployeeRoleTypes } from 'src/app/modules/shared/enums/employees/EmployeeRoleTypes';
import { DepartmentVisibilities } from 'src/app/modules/shared/enums/departmentVisibility.enum';
import { FilterTypes } from 'src/app/modules/shared/enums/filterTypes';
import { ModuleTypes } from 'src/app/modules/settings/enums/moduleTypes';
import { PermissionViewModel } from 'src/app/modules/shared/viewModels/permissionViewModel';
import { EmployeeUtil } from 'src/app/modules/shared/utilities/employee.utilities';
import { T } from 'src/assets/i18n/translation-keys';

enum ReadWriteTypes {
  read = 'read',
  write = 'write',
}

@Component({
    selector: 'app-runsheet-employee-permissions',
    templateUrl: './runsheet-employee-permissions.component.html',
    styleUrls: ['./runsheet-employee-permissions.component.scss'],
    standalone: false
})
export class RunsheetEmployeePermissionsComponent implements OnInit, OnChanges {
  @Input() employeeDetailsViewModel: EmployeeDetailsViewModel;
  @Input() isInPrimaryRole: boolean;
  @Input() isAccountAdmin: boolean;
  @Input() isDepartmentSelected: boolean;
  public readonly employeeRoleTypes = EmployeeRoleTypes;
  public readDepVisibility: DepartmentVisibilities;
  public writeDepVisibility: DepartmentVisibilities;
  public isAdmin: boolean = false;
  public readonly T = T;

  private account: Account;
  private employee: Employee;
  private readonly runsheetsFilterTypes = [FilterTypes.Runsheet, FilterTypes.Runsheet_Item];

  constructor(
    private readonly authenticationService: AuthenticationService,
    private readonly changeDetectorRef: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.employee = this.authenticationService.getCurrentEmployee();
    this.account = this.authenticationService.getCurrentAccount();

    if (this.isInPrimaryRole) {
      this.isAdmin = this.isInPrimaryRole;
    }

    this.initDepartmentVisibilities();
  }

  ngOnChanges(): void {
    this.isAdmin = this.isInPrimaryRole;
    this.initDepartmentVisibilities();
  }
  selectRunsheetsUserRole(isAdd: boolean) {
    if (isAdd) {
      this.employeeDetailsViewModel.modulePermissionViewModels.push({
        employeeId: this.employeeDetailsViewModel.id,
        id: 0,
        module: ModuleTypes.Runsheets,
        objectType: 0,
        created: '',
        accountId: this.employee.accountId,
        createdById: this.employee.id
      });
      this.readDepVisibility = DepartmentVisibilities.All_Departments;
      this.writeDepVisibility = DepartmentVisibilities.All_Departments;
      this.addPermissions();
    } else {
      this.employeeDetailsViewModel.modulePermissionViewModels = this.employeeDetailsViewModel.modulePermissionViewModels.filter(
        (r) => r.module != ModuleTypes.Runsheets
      );
      this.employeeDetailsViewModel.permissions = this.employeeDetailsViewModel.permissions.filter(
        (p) => p.module != ModuleTypes.Runsheets
      );
    }

    this.changeDetectorRef.detectChanges();
  }

  hasAccessToModule() {
    return EmployeeUtil.hasAccessToModule(this.employeeDetailsViewModel, ModuleTypes.Runsheets);
  }

  addPermissions() {
    this.runsheetsFilterTypes.forEach((ft) => {
      this.employeeDetailsViewModel.permissions.push(this.generatePermission(ft, 0, this.readDepVisibility, ReadWriteTypes.read));
      this.employeeDetailsViewModel.permissions.push(
        this.generatePermission(ft, 0, this.writeDepVisibility, ReadWriteTypes.write)
      );
    });
  }

  private initDepartmentVisibilities() {
    this.readDepVisibility = this.getDepartmentVisibility(ReadWriteTypes.read);
    this.writeDepVisibility = this.getDepartmentVisibility(ReadWriteTypes.write);
  }

  getDepartmentVisibility(readOrWrite: ReadWriteTypes) {
    const finded = this.employeeDetailsViewModel.permissions.filter(
      (f) =>
        f.module == ModuleTypes.Runsheets &&
        (readOrWrite === ReadWriteTypes.read ? f[ReadWriteTypes.read] && !f[ReadWriteTypes.write] : f[ReadWriteTypes.write])
    );
    if (finded && finded.length > 0) {
      return finded[0].departmentVisibility;
    }
  }

  public isInAdminRole(): boolean {
    return this.isInPrimaryRole || this.isAdmin;
  }

  generatePermission(
    filterType: FilterTypes,
    value: number,
    departmentVisibility: DepartmentVisibilities,
    readOrWrite: ReadWriteTypes,
    level: number = 0
  ) {
    const obj: PermissionViewModel = {
      module: ModuleTypes.Runsheets,
      type: filterType,
      value: value,
      departmentVisibility: departmentVisibility,
      read: readOrWrite === ReadWriteTypes.read || readOrWrite === ReadWriteTypes.write,
      write: readOrWrite === ReadWriteTypes.write,
      confidential: false,
      level: level,
      employeeId: this.employeeDetailsViewModel.id,
      accountId: +this.account.id,
      id: 0,
      createdById: this.employee.id
    };
    return obj;
  }
}
